import * as actionType from '../action';

const initialState = {
  isAuth: false,
  email: '',
  uid: '',
};

const authReducer = (state = initialState, action) => {
  // console.log(action);
  switch (action.type) {
    case actionType.UPDATE:
      return {
        ...state,
        isAuth: action.isLogIn,
        email: action.email,
        uid: action.uid,
      };
    default:
      return {
        ...state,
      };
  }
};

export default authReducer;
